module.exports = __webpack_public_path__ + "media/backgrounds/wod_background1-019e31a8.png";